import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { getCities } from 'models/cities'; // Importing function to get cities data
import { getTags } from 'models/tags'; // Importing function to get tags data
import { getPositions } from 'models/positions'; // Importing function to get positions data
import 'webix/photo'; // Importing photo component from webix
import 'webix/tinymce/tinymce'; // Importing TinyMCE editor from webix
import { devConfig, profile } from 'config/config'; // Importing configuration settings

/**
 * InformationView class extends JetView to create a user information form.
 */
export default class InformationView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Get the current screen size
        var arrayEdit = []; // Array to hold edited partners
        var arrayWithoutEdit = []; // Array to hold partners not edited

        // Main information form configuration
        const main_info = {
            margin: 10,
            rows: [
                {
                    view: 'text',
                    name: 'Id',
                    label: _('ID'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Id'), // Localized placeholder
                    invalidMessage: _('A ID is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Name',
                    label: _('Primer nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Primer nombre'), // Localized placeholder
                    invalidMessage: _('A name is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Login',
                    label: _('Login para acceso'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Login para acceso'), // Localized placeholder
                    disabled: !devConfig.getPermAction(
                        'informationAdminUsersLoginEdit',
                        'Add', // Check permission for editing login
                    ),
                },
                {
                    view: 'text',
                    name: 'MiddleName',
                    label: _('Segundo Nombre'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Segundo Nombre'), // Localized placeholder
                    invalidMessage: _('A name is required'), // Validation message
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'LastName',
                    label: _('Apellido'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Apellido'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'DocNumber',
                    label: _('Numero de Documento'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Numero de Documento'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'Gender',
                    localId: 'Gender:combo', // Local ID for the component
                    label: _('Género'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: ['M', 'F'], // Gender options
                    disabled: true, // Field is disabled
                },
                {
                    view: 'datepicker',
                    name: 'BirthDate',
                    label: _('Cumpleaños'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    format: webix.Date.dateToStr('%d %M %Y'), // Date format
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Currency',
                    label: _('Moneda'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Moneda'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Balance',
                    label: _('Balance'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Balance'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'Estado',
                    label: _('Estado'), // Localized label
                    labelPosition: 'top',
                    localId: 'Estado:combo', // Local ID for the component
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [
                        { id: 'A', value: _('Active') }, // Active option
                        { id: 'I', value: _('Inactive') }, // Inactive option
                    ],
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'IsLocked',
                    label: _('Está bloqueado?'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Está bloqueado?'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'combo',
                    name: 'AgentId',
                    minWidth: 200,
                    label: "<span class='icon-shop'></span>" + _('Concesionario'), // Localized label with icon
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: {
                        body: {
                            dataFeed: function (text) {
                                var vthis = this; // Reference to the current context
                                if (text.length > 2) {
                                    // Trigger data fetch if input length is greater than 2
                                    webix
                                        .ajax()
                                        .headers({
                                            'Content-type': 'application/json', // Set content type
                                        })
                                        .post(
                                            devConfig.geturlApi() + 'Agent/GetAllAgents', // API endpoint
                                            '{"Filter":"' + text + '"}', // Request body
                                            {
                                                error: function (text, data, XmlHttpRequest) {
                                                    webix.message('Error! '); // Error message
                                                },
                                                success: function (text, data, XmlHttpRequest) {
                                                    var resp = JSON.parse(text); // Parse response
                                                    if (!resp.HasError) {
                                                        vthis.parse(resp.data); // Populate options
                                                    }
                                                },
                                            },
                                        );
                                }
                            },
                        },
                    },
                },
                {
                    view: 'combo',
                    name: 'RegionPerfil',
                    minWidth: 200,
                    label: _('Región Perfil'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    hidden: profile.PartnerSelected != 8, // Hide based on profile condition
                    options: [
                        { id: 'CENTRO', value: _('CENTRO') }, // Region options
                        { id: 'COSTA', value: _('COSTA') },
                        { id: 'AUSTRO', value: _('AUSTRO') },
                    ],
                },
                {
                    view: 'text',
                    name: 'UserProfile',
                    label: _('Usuario Perfil'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Usuario Perfil'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'LastLoginDate',
                    label: _('Fecha último login'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Fecha último login'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'LastPasswordChangeDate',
                    label: _('Fecha último cambio contraseña'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Fecha último cambio contraseña'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'AccountActivatedDate',
                    label: _('Fecha cuenta activó/desactivo'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Fecha cuenta activó/desactivo'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
            ],
        };

        // Notifications configuration
        const notifications = {
            view: 'radio',
            name: 'notifications',
            label: _('Notificaciones'), // Localized label
            labelPosition: 'top',
            value: 1, // Default value
            options: [
                { id: 1, value: _('Si') }, // Yes option
                { id: 2, value: _('No') }, // No option
            ],
        };

        // Left main section configuration
        const left_main = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [main_info], // Contains main information
        };

        // More information section configuration
        const more_info = {
            gravity: 3,
            minWidth: 200,
            margin: 10,
            rows: [
                {
                    view: 'richselect',
                    name: 'CountryId',
                    id: 'country', // Local ID for the component
                    localId: 'country:combo', // Local ID for the component
                    label: _('País Residencia'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [], // Options will be populated dynamically
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'RegionId',
                    id: 'ProvinceRegion', // Local ID for the component
                    localId: 'ProvinceRegion:combo', // Local ID for the component
                    label: _('Provincia/Región Residencia'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [], // Options will be populated dynamically
                    disabled: true, // Field is disabled
                },
                {
                    view: 'richselect',
                    name: 'CityId',
                    id: 'City', // Local ID for the component
                    localId: 'cities:combo', // Local ID for the component
                    label: _('Ciudad Residencia'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Click para seleccionar '), // Localized placeholder
                    options: [], // Options will be populated dynamically
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Address',
                    label: _('Dirección'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Dirección'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'ZipCode',
                    label: _('Código Zip'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Código Zip'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Phone',
                    label: _('Teléfono'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Teléfono'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'MobilePhone',
                    label: _('Celular'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Celular'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Email',
                    label: _('Email'), // Localized label
                    labelPosition: 'top',
                    placeholder: 'Email', // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'CreatedLocalDate',
                    label: _('Fecha de registro'), // Localized label
                    labelPosition: 'top',
                    placeholder: _('Fecha de registro'), // Localized placeholder
                    disabled: true, // Field is disabled
                },
                {
                    view: 'forminput',
                    name: 'Partners',
                    id: 'formPartnersEdit', // Local ID for the component
                    body: {
                        view: 'dbllist', // Double list component for selecting partners
                        id: 'dbllistEdit', // Local ID for the component
                        list: { height: 200, scroll: true }, // List configuration
                        labelLeft: _('Partners no Seleccionados'), // Localized label
                        labelRight: _('Partners Seleccionados'), // Localized label
                        data: profile.Partners, // Initial data for partners
                    },
                    labelWidth: 140,
                    labelAlign: 'right',
                    disabled: false, // Field is enabled
                },
            ],
        };

        // Right photo section configuration
        const right_photo = {
            gravity: 3,
            margin: 10,
            rows: [
                {
                    view: 'photo', // Photo component for user image
                    name: 'photo',
                    css: 'form_photo', // CSS class for styling
                    width: 260,
                    height: 260,
                    borderless: true, // No border
                },
                {
                    view: 'multicombo', // Multi-select combo for tags
                    name: 'tags',
                    localId: 'tags:combo', // Local ID for the component
                    placeholder: _('Click to add tags'), // Localized placeholder
                    options: [], // Options will be populated dynamically
                },
            ],
        };

        // Upper section configuration
        const upper_section = {
            multiview: true, // Enable multi-view
            padding: 10,
            cols: [left_main, { gravity: 0, minWidth: 20 }, more_info], // Columns layout
        };

        // Narrow upper section configuration for small screens
        const upper_section_narrow = {
            cols: [
                {
                    gravity: 4,
                    margin: 10,
                    rows: [main_info, more_info], // Contains main and more information
                },
            ],
        };

        // Buttons configuration
        const buttons = {
            margin: 10,
            cols: [
                {},
                {
                    view: 'button',
                    value: _('Guardar'), // Localized button label
                    type: 'form', // Button type
                    autowidth: true, // Auto width
                    click: () => {
                        const newdata = this.getRoot().getValues(); // Get form values
                        newdata.Partners = arrayEdit; // Add edited partners
                        arrayWithoutEdit = []; // Reset array for non-edited partners
                        for (var i = 0; i < profile.Partners.length; i++) {
                            var flag = false; // Flag to check if partner is edited
                            for (var j = 0; (j < arrayEdit.length) & !flag; j++) {
                                if (profile.Partners[i].id == arrayEdit[j]) flag = true; // Set flag if partner is edited
                            }
                            if (!flag) arrayWithoutEdit.push(profile.Partners[i].id); // Add non-edited partner
                        }
                        newdata.PartnersWithoutAdd = arrayWithoutEdit; // Add non-edited partners to data
                        webix
                            .ajax()
                            .headers({
                                'Content-type': 'application/json', // Set content type
                            })
                            .post(
                                devConfig.geturlApi() + 'AdminUser/UpdateAdminUser', // API endpoint
                                newdata, // Data to send
                                {
                                    error: function (text, data, XmlHttpRequest) {
                                        webix.message('Error! '); // Error message
                                    },
                                    success: function (text, data, XmlHttpRequest) {
                                        webix.message('Usuario Editado'); // Success message
                                        vthis.app.callEvent(
                                            'customer:updatedata',
                                            [vthis.getParam('user', true)], // Trigger update event
                                        );
                                    },
                                },
                            );
                    },
                },
            ],
        };

        // Event listener for partner changes
        this.on(this.app, 'onChangePartnets', (array) => {
            if (array[0] != '') {
                arrayEdit = array; // Update edited partners
            } else {
                arrayEdit = []; // Reset if no partners selected
            }
        });

        webix.ui.fullScreen(); // Set UI to full screen

        // Return the main form configuration
        return {
            view: 'form',
            rows: [
                screen !== 'small' ? upper_section : upper_section_narrow, // Choose layout based on screen size
                devConfig.getPermAction('editAdminUserManagementButton', 'Edit')
                    ? buttons // Show buttons if permission granted
                    : {},
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        var vthis = this; // Reference to the current context

        // Event listener for double list changes
        $$('dbllistEdit').attachEvent('onChange', function (id, e, node) {
            vthis.app.callEvent('onChangePartnets', [
                $$('dbllistEdit').getValue().split(','), // Trigger event with selected partners
            ]);
        });

        // Event listener for form update
        this.on(this.app, 'form:update2', (id) => {
            webix.ajax().get(
                devConfig.geturlApi() + 'Client/GetClientById', // API endpoint
                'id=' + id, // Query parameter
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error message
                    },
                    success: function (text, data, XmlHttpRequest) {
                        text = JSON.parse(text); // Parse response
                        vthis.app.callEvent('customer:updatedata', [
                            text[0], // Trigger update event with client data
                        ]);
                        $$('country').setValue(text[0].CountryId); // Set country value
                        webix.delay(
                            function () {
                                $$('ProvinceRegion').setValue(
                                    text[0].RegionId, // Set region value
                                );
                                webix.delay(
                                    function () {
                                        $$('City').setValue(text[0].CityId); // Set city value
                                    },
                                    '',
                                    '',
                                    1000, // Delay for setting city value
                                );
                            },
                            '',
                            '',
                            1000, // Delay for setting region value
                        );
                    },
                },
            );
        });

        // Fetch countries for the country select
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json', // Set content type
            })
            .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message('Error! '); // Error message
                },
                success: function (text, data, XmlHttpRequest) {
                    var data = JSON.parse(
                        text
                            .replace(/"Id"/g, '"id"') // Normalize key names
                            .replace(/"Name"/g, '"value"'),
                    );
                    webix.delay(
                        function () {
                            var optionsCountries = $$('country').getList(); // Get country list
                            optionsCountries.clearAll(); // Clear existing options
                            optionsCountries.parse(data.Data); // Populate with new data
                            vthis.app.callEvent('form:update2', [
                                vthis.getParam('user', true), // Trigger update event
                            ]);
                        },
                        '',
                        '',
                        1000, // Delay for populating countries
                    );
                },
            });

        // Event listener for customer data update
        this.on(this.app, 'customer:updatedata', (person) => {
            form.setValues(person); // Set form values with customer data
            vthis.app.callEvent('onChangePartnets', [
                $$('dbllistEdit').getValue().split(','), // Trigger event with selected partners
            ]);
        });

        // Event listener for person selection
        this.on(this.app, 'person:select', (person) => form.setValues(person)); // Set form values with selected person

        // Event listener for country change
        $$('country').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv); // Get selected country
            var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get province/region list
            optionsProvinceRegions.clearAll(); // Clear existing options
            if (optionscountries != undefined) {
                optionsProvinceRegions.parse(optionscountries.departments); // Populate with new data
            }
        });

        // Event listener for province/region change
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province/region
            var optionsCity = $$('City').getList(); // Get city list
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.cities); // Populate with new data
            }
        });
    }

    /**
     * Fetches and sets localized options for combo components.
     */
    getLocalizedComboOptions() {
        const _ = this.app.getService('locale')._; // Localization service
        let p_options = webix.copy(getPositions()); // Get positions data
        p_options.map((x) => (x.value = _(x.value))); // Localize position values
        this.$$('position:combo').getPopup().getList().parse(p_options); // Populate position combo

        let t_options = webix.copy(getTags()); // Get tags data
        t_options.map((x) => (x.value = _(x.value))); // Localize tag values
        this.$$('tags:combo').getPopup().getList().parse(t_options); // Populate tags combo

        let c_options = webix.copy(getCities()); // Get cities data
        c_options.map((x) => (x.value = _(x.value))); // Localize city values
        this.$$('cities:combo').getPopup().getList().parse(c_options); // Populate cities combo
    }
}

// FILE DOCUMENTED
